import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export function catalogFormSyncWizardFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    {
      fieldGroupClassName: 'grid mb-2',
      fieldGroup: [
        {
          key: 'importUrl',
          type: 'input',
          className: 'col-8',
          props: {
            label: translate.instant('CATALOG.IMPORT_URL'),
          },
        },
        {
          key: 'privateImportKey',
          type: 'input',
          className: 'col-4',
          props: {
            label: translate.instant('CATALOG.PRIVATE_IMPORT_KEY'),
            type: 'password',
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'grid mb-2',
      fieldGroup: [
        {
          key: 'exportUrl',
          type: 'input',
          className: 'col-8',
          props: {
            label: translate.instant('CATALOG.EXPORT_URL'),
          },
        },
        {
          key: 'privateExportKey',
          type: 'input',
          className: 'col-4',
          props: {
            label: translate.instant('CATALOG.PRIVATE_EXPORT_KEY'),
            type: 'password',
          },
        },
      ],
    },
  ];
}
